import { getFieldNamefromDataPath } from '../../utils/helper';

// import schemas
import AntragSchema from '../paths/antrag_FULL_Paths.json';
import FoerderProgrammSchema from '../paths/foerderprogramm_FULL_Paths.json';
import FoerderRichtlinie from '../paths/foerderrichtlinie_FULL_Paths.json';
import KostenpositionSchema from '../paths/kostenposition_FULL_Paths.json';
import NachweisPositionSchema from '../paths/nachweisposition_FULL_Paths.json';
import { ANTRAG_TYP, ART_DES_ANTRAGS } from './constant';
const NP_P = NachweisPositionSchema.attributes;
const FP_P = FoerderProgrammSchema.attributes;
const FR_P = FoerderRichtlinie.attributes;
const P = AntragSchema.attributes;
const KP_P = KostenpositionSchema.attributes;

/**
 * *************************************************************************************************************************************************************
 * ****************************************************** Förderrichtlinien ************************************************************************************
 * *************************************************************************************************************************************************************
 */

export const MEDIAN_DOWNLOADS_DATEIEN_PATHS = {
	DateiArt: getFieldNamefromDataPath(FR_P.Medien_Downloads_Dateien.schema.attributes.Dateiart.path),
	Titel: getFieldNamefromDataPath(FR_P.Medien_Downloads_Dateien.schema.attributes.Titel.path),
	Datei: getFieldNamefromDataPath(FR_P.Medien_Downloads_Dateien.schema.attributes.Datei.path),
	DateiName: `${getFieldNamefromDataPath(FR_P.Medien_Downloads_Dateien.schema.attributes.Datei.path)}.attributes.name`,
	DateiUrl: `${getFieldNamefromDataPath(FR_P.Medien_Downloads_Dateien.schema.attributes.Datei.path)}.attributes.url`,
};

export const ANTRAG_ALLGEMEIN_DOWNLOADS_PATHS = {
	Titel: getFieldNamefromDataPath(FR_P.Antrag_Allgemeine_Downloads_Dateien.schema.attributes.Titel.path),
	Datei: getFieldNamefromDataPath(FR_P.Antrag_Allgemeine_Downloads_Dateien.schema.attributes.Datei.path),
	DateiName: `${getFieldNamefromDataPath(FR_P.Antrag_Allgemeine_Downloads_Dateien.schema.attributes.Datei.path)}.attributes.name`,
	DateiUrl: `${getFieldNamefromDataPath(FR_P.Antrag_Allgemeine_Downloads_Dateien.schema.attributes.Datei.path)}.attributes.url`,
};

/**
 * *************************************************************************************************************************************************************
 * ******************************************************** Förderprogramm ************************************************************************************
 * *************************************************************************************************************************************************************
 */

export const FOERDERPROGRAMM_EINREICHENFRIST_PATHS = {
	// Mittelabruf
	mitttelabrufVonTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Mittelabruf_Von_Tag.path),
	mitttelabrufVonMonat: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Mittelabruf_Von_Monat.path),
	mitttelabrufBisTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Mittelabruf_Bis_Tag.path),
	mitttelabrufBisMonat: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Mittelabruf_Bis_Monat.path),
	anleitungMittelabruf: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Anleitung_Mittelabruf.path),
	// Verwendungsnachweis
	vnImProjektVonJahrVonTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.VN_Projektjahr_Von_Tag.path),
	vnImProjektVonJahrVonMonat: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.VN_Projektjahr_Von_Monat.path),
	vnImProjektBisJahrBisTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.VN_Projektjahr_Bis_Tag.path),
	vnImProjektBIsJahrBisTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.VN_Projektjahr_Bis_Monat.path),
	vnNachAbschlussTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.VN_Abschluss_Tag.path),
	vnNachAbschlussMonat: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.VN_Abschluss_Monat.path),
	// Zwischenabrechnung
	znNotwendig: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Einreichfristen_Zwischenbericht_Notwendig_Notwendig.path),
	znMedienInterval: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Einreichfristen_Zwischenbericht_Notwendig_Meldeintervall.path),
	znBisTag: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Zwischenbericht.schema.attributes.Zwischenbericht_Bis_Tag.path),
	znBisMonat: getFieldNamefromDataPath(FP_P.Einreichfristen.schema.attributes.Zwischenbericht.schema.attributes.Zwischenbericht_Bis_Monat.path),
};

export const FOERDERPROGRAMM_FOERDERQUOTE_ANTRAGSBERECHTIGTE_PATHS = {
	Antragsberechtigte: getFieldNamefromDataPath(FP_P.Foerderquote_Antragsberechtigte.schema.attributes.Antragsberechtigte.path),
	AntragberechtigtID: `${getFieldNamefromDataPath(FP_P.Foerderquote_Antragsberechtigte.schema.attributes.Antragsberechtigte.path)}.id`,
	AntragsberechtigteName: `${getFieldNamefromDataPath(FP_P.Foerderquote_Antragsberechtigte.schema.attributes.Antragsberechtigte.path)}.attributes.Name`,
	Foerdergegenstand: getFieldNamefromDataPath(FP_P.Foerderquote_Antragsberechtigte.schema.attributes.Foerdergegenstand.path),
	Max_Foerderquote: getFieldNamefromDataPath(FP_P.Foerderquote_Antragsberechtigte.schema.attributes.Max_Foerderquote.path),
	Max_Foerdersumme: getFieldNamefromDataPath(FP_P.Foerderquote_Antragsberechtigte.schema.attributes.Max_Foerdersumme.path),
};

// Allgemeine Hinweise PATHS
export const FOERDERPROGRAMM_ALLGEMINE_HINWEISE_ANTRAG_PATHS = {
	[ART_DES_ANTRAGS.Formantrag]: {
		HinweisBlock: FP_P.Allgemeine_Hinweise_Zum_Formantrag.path,
		Titel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Formantrag.schema.attributes.Titel.path),
		Untertitel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Formantrag.schema.attributes.Untertitel.path),
		Inhalte: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Formantrag.schema.attributes.Inhalt.path),
		Bild: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Formantrag.schema.attributes.Bild.path),
	},
	[ANTRAG_TYP.Antrag]: {
		HinweisBlock: FP_P.Allgemeine_Hinweise_Zum_Antrag.path,
		Titel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Antrag.schema.attributes.Titel.path),
		Untertitel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Antrag.schema.attributes.Untertitel.path),
		Inhalte: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Antrag.schema.attributes.Inhalt.path),
		Bild: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Antrag.schema.attributes.Bild.path),
	},
	[ANTRAG_TYP.Skizze]: {
		HinweisBlock: FP_P.Allgemeine_Hinweise_Zur_Skizze.path,
		Titel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zur_Skizze.schema.attributes.Titel.path),
		Untertitel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zur_Skizze.schema.attributes.Untertitel.path),
		Inhalte: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zur_Skizze.schema.attributes.Inhalt.path),
		Bild: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zur_Skizze.schema.attributes.Bild.path),
	},
};

// Dateien je Antrag PATHS
export const FOERDERPROGRAMM_DATEIEN_JE_ANTRAG_PATHS = {
	[ART_DES_ANTRAGS.Formantrag]: {
		Inhalt: FP_P.Downloads_Zum_Formantrag_Inhalt.path,
		DateienBlock: FP_P.Downloads_Zum_Formantrag_Dateien.path,
		Titel: getFieldNamefromDataPath(FP_P.Downloads_Zum_Formantrag_Dateien.schema.attributes.Titel.path),
		Dateien: getFieldNamefromDataPath(FP_P.Downloads_Zum_Formantrag_Dateien.schema.attributes.Datei.path),
		DateienName: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Formantrag_Dateien.schema.attributes.Datei.path)}.attributes.name`,
		DateienUrl: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Formantrag_Dateien.schema.attributes.Datei.path)}.attributes.url`,
	},
	[ANTRAG_TYP.Antrag]: {
		Inhalt: FP_P.Downloads_Zum_Antrag_Inhalt.path,
		DateienBlock: FP_P.Downloads_Zum_Antrag_Dateien.path,
		Titel: getFieldNamefromDataPath(FP_P.Downloads_Zum_Antrag_Dateien.schema.attributes.Titel.path),
		Dateien: getFieldNamefromDataPath(FP_P.Downloads_Zum_Antrag_Dateien.schema.attributes.Datei.path),
		DateienName: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Antrag_Dateien.schema.attributes.Datei.path)}.attributes.name`,
		DateienUrl: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Antrag_Dateien.schema.attributes.Datei.path)}.attributes.url`,
	},
	[ANTRAG_TYP.Skizze]: {
		Inhalt: FP_P.Downloads_Zur_Skizze_Inhalt.path,
		DateienBlock: FP_P.Downloads_Zur_Skizze_Dateien.path,
		Titel: getFieldNamefromDataPath(FP_P.Downloads_Zur_Skizze_Dateien.schema.attributes.Titel.path),
		Dateien: getFieldNamefromDataPath(FP_P.Downloads_Zur_Skizze_Dateien.schema.attributes.Datei.path),
		DateienName: `${getFieldNamefromDataPath(FP_P.Downloads_Zur_Skizze_Dateien.schema.attributes.Datei.path)}.attributes.name`,
		DateienUrl: `${getFieldNamefromDataPath(FP_P.Downloads_Zur_Skizze_Dateien.schema.attributes.Datei.path)}.attributes.url`,
	},
};

// Pflicht-Erklärungen, Optionale-Erklärungen, Pflicht-Antragen, Optionale-Anlagen, Sonstige-Anlagen PATHS
export const FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS = {
	[ART_DES_ANTRAGS.Formantrag]: {
		// Pflicht Erklärung
		PflichtErklaerungTitel: FP_P.Titel_Pflichterklaerung_Formantrag.path,
		PflichtErklaerungBeschreibung: FP_P.Beschreibung_Pflichterklaerung_Formantrag.path,
		PflichtErklaerungen: FP_P.Pflichterklaerungen_Formantrag.path,
		PflichtErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Pflichterklaerungen_Formantrag.schema.attributes.Inhalt.path),

		// Optionale Erklärung
		OptionaleErklaerungTitel: FP_P.Titel_Optionale_Erklaerungen_Formantrag.path,
		OptionaleErklaerungBeschreibung: FP_P.Beschreibung_Optionale_Erklaerungen_Formantrag.path,
		OptionaleErklaerungen: FP_P.Optionale_Erklaerungen_Formantrag.path,
		OptionaleErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Optionale_Erklaerungen_Formantrag.schema.attributes.Inhalt.path),

		// Pflicht Anlagen
		PflichtAnlageTitel: FP_P.Titel_Erforderliche_Anlagen_Formantrag.path,
		PflichtAnlageUnterTitel: FP_P.Untertitel_Erforderliche_Anlagen_Formantrag.path,
		PflichtAnlageBeschreibung: FP_P.Beschreibung_Erforderliche_Anlagen_Formantrag.path,
		PflichtAnlagen: FP_P.Erforderliche_Anlagen_Formantrag.path,
		PflichtAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Formantrag.schema.attributes.Bezeichnung_Des_Dokuments.path),
		PflichtAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Formantrag.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

		// Optionale Anlagen
		OptionaleAnlageTitel: FP_P.Titel_Optionale_Anlagen_Formantrag.path,
		OptionaleAnlageUnterTitel: FP_P.Untertitel_Optionale_Anlagen_Formantrag.path,
		OptionaleAnlageBeschreibung: FP_P.Beschreibung_Optionale_Anlagen_Formantrag.path,
		OptionaleAnlagen: FP_P.Optionale_Anlagen_Formantrag.path,
		OptionaleAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Formantrag.schema.attributes.Bezeichnung_Des_Dokuments.path),
		OptionaleAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Formantrag.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

		// Sonstige Anlagen
		SontigeAnlageTitel: FP_P.Titelsonstige_Anlagen_Formantrag.path,
		SontigeAnlageUnterTitel: FP_P.Untertitel_Sonstige_Anlagen_Formantrag.path,
		SontigeAnlageBeschreibung: FP_P.Beschreibung_Sonstige_Anlagen_Formantrag.path,
	},
	[ANTRAG_TYP.Antrag]: {
		// Pflicht Erklärung
		PflichtErklaerungTitel: FP_P.Titel_Pflichterklaerung_Antrag.path,
		PflichtErklaerungBeschreibung: FP_P.Beschreibung_Pflichterklaerung_Antrag.path,
		PflichtErklaerungen: FP_P.Pflichterklaerungen_Antrag.path,
		PflichtErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Pflichterklaerungen_Antrag.schema.attributes.Inhalt.path),

		// Optionale Erklärung
		OptionaleErklaerungTitel: FP_P.Titel_Optionale_Erklaerungen_Antrag.path,
		OptionaleErklaerungBeschreibung: FP_P.Beschreibung_Optionale_Erklaerungen_Antrag.path,
		OptionaleErklaerungen: FP_P.Optionale_Erklaerungen_Antrag.path,
		OptionaleErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Optionale_Erklaerungen_Antrag.schema.attributes.Inhalt.path),

		// Pflicht Anlagen
		PflichtAnlageTitel: FP_P.Titel_Erforderliche_Anlagen_Antrag.path,
		PflichtAnlageUnterTitel: FP_P.Untertitel_Erforderliche_Anlagen_Antrag.path,
		PflichtAnlageBeschreibung: FP_P.Beschreibung_Erforderliche_Anlagen_Antrag.path,
		PflichtAnlagen: FP_P.Erforderliche_Anlagen_Antrag.path,
		PflichtAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Antrag.schema.attributes.Bezeichnung_Des_Dokuments.path),
		PflichtAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Antrag.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

		// Optionale Anlagen
		OptionaleAnlageTitel: FP_P.Titel_Optionale_Anlagen_Antrag.path,
		OptionaleAnlageUnterTitel: FP_P.Untertitel_Optionale_Anlagen_Antrag.path,
		OptionaleAnlageBeschreibung: FP_P.Beschreibung_Optionale_Anlagen_Antrag.path,
		OptionaleAnlagen: FP_P.Optionale_Anlagen_Antrag.path,
		OptionaleAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Antrag.schema.attributes.Bezeichnung_Des_Dokuments.path),
		OptionaleAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Antrag.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

		// Sonstige Anlagen
		SontigeAnlageTitel: FP_P.Titelsonstige_Anlagen_Antrag.path,
		SontigeAnlageUnterTitel: FP_P.Untertitel_Sonstige_Anlagen_Antrag.path,
		SontigeAnlageBeschreibung: FP_P.Beschreibung_Sonstige_Anlagen_Antrag.path,
	},
	[ANTRAG_TYP.Skizze]: {
		// Pflicht Erklärung
		PflichtErklaerungTitel: FP_P.Titel_Pflichterklaerung_Skizze.path,
		PflichtErklaerungBeschreibung: FP_P.Beschreibung_Pflichterklaerung_Skizze.path,
		PflichtErklaerungen: FP_P.Pflichterklaerungen_Skizze.path,
		PflichtErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Pflichterklaerungen_Skizze.schema.attributes.Inhalt.path),

		// Optionale Erklärung
		OptionaleErklaerungTitel: FP_P.Titel_Optionale_Erklaerungen_Skizze.path,
		OptionaleErklaerungBeschreibung: FP_P.Beschreibung_Optionale_Erklaerungen_Skizze.path,
		OptionaleErklaerungen: FP_P.Optionale_Erklaerungen_Skizze.path,
		OptionaleErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Optionale_Erklaerungen_Skizze.schema.attributes.Inhalt.path),

		// Pflicht Anlagen
		PflichtAnlageTitel: FP_P.Titel_Erforderliche_Anlagen_Skizze.path,
		PflichtAnlageUnterTitel: FP_P.Untertitel_Erforderliche_Anlagen_Skizze.path,
		PflichtAnlageBeschreibung: FP_P.Beschreibung_Erforderliche_Anlagen_Skizze.path,
		PflichtAnlagen: FP_P.Erforderliche_Anlagen_Skizze.path,
		PflichtAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Skizze.schema.attributes.Bezeichnung_Des_Dokuments.path),
		PflichtAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Skizze.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

		// Optionale Anlagen
		OptionaleAnlageTitel: FP_P.Titel_Optionale_Anlagen_Skizze.path,
		OptionaleAnlageUnterTitel: FP_P.Untertitel_Optionale_Anlagen_Skizze.path,
		OptionaleAnlageBeschreibung: FP_P.Beschreibung_Optionale_Anlagen_Skizze.path,
		OptionaleAnlagen: FP_P.Optionale_Anlagen_Skizze.path,
		OptionaleAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Skizze.schema.attributes.Bezeichnung_Des_Dokuments.path),
		OptionaleAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Skizze.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

		// Sonstige Anlagen
		SontigeAnlageTitel: FP_P.Titelsonstige_Anlagen_Skizze.path,
		SontigeAnlageUnterTitel: FP_P.Untertitel_Sonstige_Anlagen_Skizze.path,
		SontigeAnlageBeschreibung: FP_P.Beschreibung_Sonstige_Anlagen_Skizze.path,
	},
};

// Pflicht-Erklärungen, Optionale-Erklärungen, Pflicht-Antragen, Optionale-Anlagen, Sonstige-Anlagen PATHS für Mittelabruf
export const FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS = {
	// Pflicht Erklärung
	PflichtErklaerungTitel: FP_P.Titel_Pflichterklaerung_Mittelabruf.path,
	PflichtErklaerungBeschreibung: FP_P.Beschreibung_Pflichterklaerung_Mittelabruf.path,
	PflichtErklaerungen: FP_P.Pflichterklaerungen_Mittelabruf.path,
	PflichtErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Pflichterklaerungen_Mittelabruf.schema.attributes.Inhalt.path),

	// Optionale Erklärung
	OptionaleErklaerungTitel: FP_P.Titel_Optionale_Erklaerungen_Mittelabruf.path,
	OptionaleErklaerungBeschreibung: FP_P.Beschreibung_Optionale_Erklaerungen_Mittelabruf.path,
	OptionaleErklaerungen: FP_P.Optionale_Erklaerungen_Mittelabruf.path,
	OptionaleErklaerungenInhalt: getFieldNamefromDataPath(FP_P.Optionale_Erklaerungen_Mittelabruf.schema.attributes.Inhalt.path),

	// Pflicht Anlagen
	PflichtAnlageTitel: FP_P.Titel_Erforderliche_Anlagen_Mittelabruf.path,
	PflichtAnlageUnterTitel: FP_P.Untertitel_Erforderliche_Anlagen_Mittelabruf.path,
	PflichtAnlageBeschreibung: FP_P.Beschreibung_Erforderliche_Anlagen_Mittelabruf.path,
	PflichtAnlagen: FP_P.Erforderliche_Anlagen_Mittelabruf.path,
	PflichtAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Mittelabruf.schema.attributes.Bezeichnung_Des_Dokuments.path),
	PflichtAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Erforderliche_Anlagen_Mittelabruf.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

	// Optionale Anlagen
	OptionaleAnlageTitel: FP_P.Titel_Optionale_Anlagen_Mittelabruf.path,
	OptionaleAnlageUnterTitel: FP_P.Untertitel_Optionale_Anlagen_Mittelabruf.path,
	OptionaleAnlageBeschreibung: FP_P.Beschreibung_Optionale_Anlagen_Mittelabruf.path,
	OptionaleAnlagen: FP_P.Optionale_Anlagen_Mittelabruf.path,
	OptionaleAnlagenBezeichnung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Mittelabruf.schema.attributes.Bezeichnung_Des_Dokuments.path),
	OptionaleAnlagenErlaeuterung: getFieldNamefromDataPath(FP_P.Optionale_Anlagen_Mittelabruf.schema.attributes.Erlaeuterungen_Zum_Dokument.path),

	// Sonstige Anlagen
	SontigeAnlageTitel: FP_P.Titelsonstige_Anlagen_Mittelabruf.path,
	SontigeAnlageUnterTitel: FP_P.Untertitel_Sonstige_Anlagen_Mittelabruf.path,
	SontigeAnlageBeschreibung: FP_P.Beschreibung_Sonstige_Anlagen_Mittelabruf.path,
};

// Abschluss Texte PATHS
export const FOERDERPROGRAMM_ABSCHLUSS_TEXTE_PATHS = {
	[ART_DES_ANTRAGS.Formantrag]: {
		AbschlussTexteBlock: FP_P.Texte_Abschluss_Zum_Formantrag.path,
		Titel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Formantrag.schema.attributes.Titel.path),
		UnterTitel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Formantrag.schema.attributes.Untertitel.path),
		Tab: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Formantrag.schema.attributes.Tab.path),
		Inhalt: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Formantrag.schema.attributes.Inhalt.path),
	},
	[ANTRAG_TYP.Antrag]: {
		AbschlussTexteBlock: FP_P.Texte_Abschluss_Zum_Antrag.path,
		Titel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Antrag.schema.attributes.Titel.path),
		UnterTitel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Antrag.schema.attributes.Untertitel.path),
		Tab: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Antrag.schema.attributes.Tab.path),
		Inhalt: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Antrag.schema.attributes.Inhalt.path),
	},
	[ANTRAG_TYP.Skizze]: {
		AbschlussTexteBlock: FP_P.Texte_Abschluss_Zur_Skizze.path,
		Titel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zur_Skizze.schema.attributes.Titel.path),
		UnterTitel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zur_Skizze.schema.attributes.Untertitel.path),
		Tab: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zur_Skizze.schema.attributes.Tab.path),
		Inhalt: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zur_Skizze.schema.attributes.Inhalt.path),
	},
};

// Allgemeine Hinweise MITTELABRUF PATHS
export const FOERDERPROGRAMM_ALLGEMINE_HINWEISE_MA_PATHS = {
	HinweisBlock: FP_P.Allgemeine_Hinweise_Zum_Mittelabruf.path,
	Titel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Mittelabruf.schema.attributes.Titel.path),
	Untertitel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Mittelabruf.schema.attributes.Untertitel.path),
	Inhalte: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Mittelabruf.schema.attributes.Inhalt.path),
	Bild: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Mittelabruf.schema.attributes.Bild.path),
};

// Dateien je Antrag PATHS
export const FOERDERPROGRAMM_DATEIEN_JE_MA_PATHS = {
	Inhalt: FP_P.Downloads_Zum_Mittelabruf_Inhalt.path,
	DateienBlock: FP_P.Downloads_Zum_Mittelabruf_Dateien.path,
	Titel: getFieldNamefromDataPath(FP_P.Downloads_Zum_Mittelabruf_Dateien.schema.attributes.Titel.path),
	Dateien: getFieldNamefromDataPath(FP_P.Downloads_Zum_Mittelabruf_Dateien.schema.attributes.Datei.path),
	DateienName: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Mittelabruf_Dateien.schema.attributes.Datei.path)}.attributes.name`,
	DateienUrl: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Mittelabruf_Dateien.schema.attributes.Datei.path)}.attributes.url`,
};

// Dateien je Verwendungsnachweis PATHS
export const FOERDERPROGRAMM_DATEIEN_JE_VN_PATHS = {
	Inhalt: FP_P.Downloads_Zum_Verwendungsnachweis_Inhalt.path,
	DateienBlock: FP_P.Downloads_Zum_Verwendungsnachweis_Dateien.path,
	Titel: getFieldNamefromDataPath(FP_P.Downloads_Zum_Verwendungsnachweis_Dateien.schema.attributes.Titel.path),
	Dateien: getFieldNamefromDataPath(FP_P.Downloads_Zum_Verwendungsnachweis_Dateien.schema.attributes.Datei.path),
	DateienName: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Verwendungsnachweis_Dateien.schema.attributes.Datei.path)}.attributes.name`,
	DateienUrl: `${getFieldNamefromDataPath(FP_P.Downloads_Zum_Verwendungsnachweis_Dateien.schema.attributes.Datei.path)}.attributes.url`,
};

// Abschluss Texte MITTELABRUF PATHS
export const FOERDERPROGRAMM_ABSCHLUSS_TEXTE_MA_PATHS = {
	AbschlussTexteBlock: FP_P.Texte_Abschluss_Zum_Mittelabruf.path,
	Titel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Mittelabruf.schema.attributes.Titel.path),
	UnterTitel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Mittelabruf.schema.attributes.Untertitel.path),
	Tab: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Mittelabruf.schema.attributes.Tab.path),
	Inhalt: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Mittelabruf.schema.attributes.Inhalt.path),
};

// Allgemeine Hinweise VERWENDUNGNACHWEIS PATHS
export const FOERDERPROGRAMM_ALLGEMINE_HINWEISE_VN_PATHS = {
	HinweisBlock: FP_P.Allgemeine_Hinweise_Zum_Verwendungsnachweis.path,
	Titel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Verwendungsnachweis.schema.attributes.Titel.path),
	Untertitel: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Verwendungsnachweis.schema.attributes.Untertitel.path),
	Inhalte: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Verwendungsnachweis.schema.attributes.Inhalt.path),
	Bild: getFieldNamefromDataPath(FP_P.Allgemeine_Hinweise_Zum_Verwendungsnachweis.schema.attributes.Bild.path),
};

// Abschluss Texte VERWENDUNGNACHWEIS PATHS
export const FOERDERPROGRAMM_ABSCHLUSS_TEXTE_VN_PATHS = {
	AbschlussTexteBlock: FP_P.Texte_Abschluss_Zum_Verwendungsnachweis.path,
	Titel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Verwendungsnachweis.schema.attributes.Titel.path),
	UnterTitel: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Verwendungsnachweis.schema.attributes.Untertitel.path),
	Tab: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Verwendungsnachweis.schema.attributes.Tab.path),
	Inhalt: getFieldNamefromDataPath(FP_P.Texte_Abschluss_Zum_Verwendungsnachweis.schema.attributes.Inhalt.path),
};

/**
 * *************************************************************************************************************************************************************
 * ********************************************************** Förderaufruf ************************************************************************************
 * *************************************************************************************************************************************************************
 */

// autofold/fold_next
export const PERSONALAUSHABEN_STARTUPPROJEKTE = {
	NameDerPerson: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Name_Der_Im_Vorhaben_Beschaeftigten_Person.path,
	),
	Jahr: getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Block_1.schema.attributes.Zelle_1.path),
	VorhabenTaetig: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Im_Beantragten_Vorhaben_Taetig.path,
	),
	WochenStunden: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Wochenstunden_Laut_Arbeitsvertrag.path,
	),
	volleEinsatzmonaten: getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Block_1.schema.attributes.Zelle_2.path),
	maxEinsatzStunden: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_max_46_Einsatzstunden_Errechnet.path,
	),
	Leistungsgruppe: getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_P_Leistungsgruppe.path),
	// BeschreibungVorhaben: getFieldNamefromDataPath(
	// 	KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Konkrete_Beschreibung_Im_Beantragten_Vorhaben.path
	// ),
	// BeschreibungAufgaben: getFieldNamefromDataPath(
	// 	KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Darstellung_Der_Eignung_Vergleichbaren_Aufgaben.path
	// ),
	// BeschreibungMerkblatt: getFieldNamefromDataPath(
	// 	KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Begruendung_Der_Zuordnung_Gemaess_Merkblatt.path
	// ),
	MonatOrStundenSatz: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Monatssatz_Bzw_Stundensatz.path,
	),
	AnzahlMonatOrStunden: getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Block_1.schema.attributes.Zelle_4.path),
	Ausgaben: getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Block_1.path),
};

export const PERSONALAUSGABEN_KREATIVWIRTSCHAFT_COMPONENT_PATHS = {
	NameDerPerson: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Name_Desder_Beschaeftigten.path,
	),
	ArtDerLeitung: getFieldNamefromDataPath(KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path),
	Leistungsgruppe: getFieldNamefromDataPath(KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Leistungsgruppe.path),
	StundenSatz: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe.path,
	),
	StundenProWoche: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Std_Wochelt_Arbeitsvertrag.path,
	),
	StellanteilImVorhaben: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Stellenanteil_Im_Vorhabenin.path,
	),
	Einsatzmonate: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Einsatzmonate_Im_Vorhaben_Im_Jahr_Der_Bewilligung.path,
	),
	ErrechneteMaxEinsatzStunden: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Errechnete_Max_Einsatzstunden_Im_Jahr_Der_Bewilligung.path,
	),
	GeplanteStundenImVorhaben: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Anzahl_Der_Geplanten_Stunden_Im_Projekt.path,
	),
	ErrechnetePauschale: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Errechnete_Pauschale_Fuer_Das_Gesamte_Vorhaben.path,
	),
	FunktionImVorhaben: getFieldNamefromDataPath(KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Funktion_Im_Beantragten_Vorhaben.path),
	TaetigkeitenImVorhaben: getFieldNamefromDataPath(KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Taetigkeiten_Im_Vorhaben.path),
	Fuehrungstaetigkeiten: getFieldNamefromDataPath(
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Gehoeren_Zu_Den_Taetigken_Fuehrungstaetigkeiten.path,
	),
	BerufsErfahrung: getFieldNamefromDataPath(KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Berufserfahrung_in_Jahren.path),
	BerufsAbschluss: getFieldNamefromDataPath(KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Berufs_Studienabschluss.path),
};

export const VN_Kalkulation_Personalausgaben_Kreativwirtschaft_COMPONENT_PATHS = {
	NameDerPerson: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Name_Desder_Beschaeftigten.path,
	),
	ArtDerLeitung: getFieldNamefromDataPath(NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Art_Der_Eigenleistung.path),
	Leistungsgruppe: getFieldNamefromDataPath(NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Leistungsgruppe.path),
	StundenSatz: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Stundensatz_Lt_Entgeltgruppe.path,
	),
	StundenProWoche: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Std_Wochelt_Arbeitsvertrag.path,
	),
	StellanteilImVorhaben: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Stellenanteil_Im_Vorhabenin.path,
	),
	Einsatzmonate: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Einsatzmonaten_Im_Jahr_Der_Bewilligung.path,
	),
	ErrechneteMaxEinsatzStunden: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Errechnete_max_Einsatzstunden_im_Jahr_der_Bewilligung.path,
	),
	ErrechnetePauschale: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Erechnete_Pauschale_Fuer_Das_Gesamte_Vorhaben.path,
	),
	FunktionImVorhaben: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Funktion_Im_Beantragten_Vorhaben.path,
	),
	TaetigkeitenImVorhaben: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Taetigkeiten_Im_Vorhaben.path,
	),
	Fuehrungstaetigkeiten: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Fuehrungstaetigkeiten.path,
	),
	BerufsErfahrung: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Berufserfahrungin_Jahren.path,
	),
	BerufsAbschluss: getFieldNamefromDataPath(
		NP_P.Kalkulation_Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativ_Berufs_Studienabschluss.path,
	),
};

export const ANTRAG_VERBUNDPARTNER = {
	PositionID: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Position_ID.path),
	Partner: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner.path),
	Name: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path),
	Kuerzel: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Kuerzel.path),
	NameGeschaeftsfuehrer: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Name_Des_Geschaeftsfuehrers.path),
	InstitutionTyp: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Institutionstyp.path),
	Antragberechtigt: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Antragsberechtigt_Als.path),
	Hochschule: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Hochschule.path),
	HochschuleName: getFieldNamefromDataPath(
		P.Verbundpartner.schema.attributes.Hochschule.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
	),
	Rechtform: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Rechtsform_Der_Organisation.path),
	StrasseUndHausnummer: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Strasse_Und_Hausnummer.path),
	Ort: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Ort.path),
	PLZ: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_PLZ.path),
	Telefon: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Telefonnummer.path),
	Email: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_E_Mail_Adresse.path),
	OeffentlicheAustraggeber: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Oeffentlicher_Auftraggeber.path),
	FoerderquoteGesamt: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Foerderquote_Gesamt_403741.path),
	FoerderQuoteBlock: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Foerderquote.path),
	Ansprechpartner: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.path),
	// relevanteFelder für KMU
	GrundungsDatum: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Gruendungsdatum.path),
	HandelRegisterNummer: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Handelsregisternummer.path),
	AbweichendSitz: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Abweichender_Sitz.path),
	AbweichendStasse: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Strasse_Und_Hausnummer.path),
	AbweichendPLZ: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.PLZ.path),
	AbweichendOrt: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Ort.path),
	// ÜberarbeitungHInweis Bloclk
	UeberarbeitungHinweisStatus: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Pruefstatus.path),
	UeberarbeitungHinweisHinweis: getFieldNamefromDataPath(
		P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
	),
	UeberarbeitungHinweisErledigt: getFieldNamefromDataPath(P.Verbundpartner.schema.attributes.Verbundpartner_Pruefung_Erledigt.path),
};

export const ANTRAG_ASSO_PARTNER = {
	Partner: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Partner.path),
	Name: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path),
	InstitutionTyp: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Institutionstyp.path),
	Rechtform: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsform_Der_Organisation.path),
	StrasseUndHausnummer: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Strasse_Und_Hausnummer.path),
	Ort: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_PLZ.path),
	PLZ: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ort.path),
	Telefon: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Telefonnummer.path),
	Email: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_E_Mail_Adresse.path),
	RelevanteKernkompetenz: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Relevante_Kernkompentenz.path),
	Ansprechpartner: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.path),
	LOIVorhanden: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden.path),
	LOIVorhanden_Datei: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path),
	LOIVorhanden_Datei_Name: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path) + '.attributes.name',
	LOIVorhanden_Datei_Url: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path) + '.attributes.url',
	LOIVorhanden_Datei_ID: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path) + '.id',
	// ÜberarbeitungHInweis Bloclk
	UeberarbeitungHinweisStatus: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Pruefstatus.path),
	UeberarbeitungHinweisHinweis: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Hinweis_Fuer_Den_Antragsteller.path),
	UeberarbeitungHinweisErledigt: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Erledigt_Durch_Antragsteller.path),
};

export const ANTRAG_VORZEITIGER_VORHABEN = {
	Grunde: 'Vorzeitiger_Vorhabenbeginn_Gruende',
	Erklaerung_1: 'Vorzeitiger_Vorhabenbeginn_Erklaerungen_Block_1_Zelle_1',
	Erklaerung_2: 'Vorzeitiger_Vorhabenbeginn_Erklaerungen_Block_2_Zelle_1',
	UnterschrieberAntrag: 'Vorzeitiger_Vorhabenbeginn_Unterschriebener_Antrag',
	PruefungStatus: 'Vorzeitiger_Vorhabenbeginn_Pruefung_Pruefstatus',
	PruefungFreigegebenAm: 'Vorzeitiger_Vorhabenbeginn_Pruefung_freigegeben_Am',
	PruefungUeberarbeitetAm: 'Vorzeitiger_Vorhabenbeginn_Pruefung_Ueberarbeitet_Am',
	PruefungErledigtAm: 'Vorzeitiger_Vorhabenbeginn_Pruefung_Erledigt',
	PruefungHinweisFuerAntragsteller: 'Vorzeitiger_Vorhabenbegin_hinnweis_Fuer_Den_Antragsteller',
};

export const KMU_PATHS = {
	PositionID: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Position_ID.path),
	Verzichtet: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Verzichtet.path),
	Einschaetzung_Als_Unternehmen: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Einschaetzung_Als_Unternehmen.path),
	Unternehmenseinschaetzung_Fuer_Nicht_Kmus: getFieldNamefromDataPath(
		P.Selbsterklaerung_KMU.schema.attributes.Unternehmenseinschaetzung_Fuer_Nicht_Kmus.path,
	),
	Unternehmen: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Unternehmen.path),
	Unternehmenstyp: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Unternehmenstyp.path),
	Unternehmenskennzahlen: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Kennzahlen.path),
	// Schwellenwerte_1: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Schwellenwerte_Zeile_1_Spalte_1.path),
	// Schwellenwerte_2: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Schwellenwerte_Zeile_2_Spalte_1.path),
	// Schwellenwerte_3: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Schwellenwerte_Zeile_3_Spalte_1.path),
	// Schwellenwerte_4: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Schwellenwerte_Zeile_4_Spalte_1.path),
	// Kriterien_1: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Kriterien_Zeile_1_Spalte_1.path),
	// Kriterien_2: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Kriterien_Zeile_2_Spalte_1.path),
	AnzahlDerMitarbeitet: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Anzahl_Der_Mitarbeiter.path),
	Jahresumsatz: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Jahresumsatz.path),
	Jahresbilanzsumme: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Jahresbilanzsumme.path),
	UnterschriebeneSelbsterklaerung: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Unterschrieben_Datei.path),
	SelbstErklaerungBerechnung: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Berechnung_Datei.path),
	Prufueng_Prufstatus: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Pruefstatus.path),
	Prufueng_Freigegeben: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Freigegeben_Am.path),
	Prufueng_UeberarbeitetAm: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Ueberarbeitet_Am.path),
	Prufueng_Erledigt: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Pruefung_Erledigt.path),
	Prufueng_HinweisAntragsteller: getFieldNamefromDataPath(P.Selbsterklaerung_KMU.schema.attributes.Kmu_Hinnweis_Antragsteller.path),
};

export const RUS_PATH = {
	PositionID: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.Position_ID.path),
	Unternehmen: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.Unternehmen.path),
	UnterschriebeneSelbsterklaerung: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.Unterschriebene_RUS_Selbsterklaerung.path),

	// Prüfung Assistenz
	Prufueng_Prufstatus: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Pruefstatus.path),
	Prufueng_Freigegeben: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Freigegeben_Am.path),
	Prufueng_UeberarbeitetAm: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Ueberarbeitet_Am.path),
	Prufueng_Erledigt: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Erledigt.path),
	Prufueng_HinweisAntragsteller: getFieldNamefromDataPath(P.Selbsterklaerung_RUS.schema.attributes.RUS_Pruefung_Hinnweis_Antragsteller.path),
};

export const BEIHILFERELEVANZ_PATH = {
	PositionID: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Position_ID.path),
	Unternehmen: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Unternehmen.path),
	Erklaerung_Beihilferelevante_Angebote: getFieldNamefromDataPath(
		P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Erklaerung_Beihilferelevante_Angebote.path,
	),
	Erklaerung_Beihilfebegriff: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Erklaerung_Beihilfebegriff.path),
	Berechnungstabelle_Umlagemodell: getFieldNamefromDataPath(
		P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Berechnungstabelle_Umlagemodell.path,
	),

	// Prüfung Assistenz
	Pruefung_Pruefstatus: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Pruefung_Pruefstatus.path),
	Pruefung_Freigegeben: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Pruefung_Freigegeben_Am.path),
	Pruefung_UeberarbeitetAm: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Pruefung_Ueberarbeitet_Am.path),
	Pruefung_Erledigt: getFieldNamefromDataPath(P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Pruefung_Erledigt.path),
	Pruefung_HinweisAntragsteller: getFieldNamefromDataPath(
		P.Beihilferelevanz_Selbsterklaerung.schema.attributes.Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
	),
};

export const PROJEKTUEBERSICHT_LOEWE_PATH = {
	Projektuebersicht: getFieldNamefromDataPath(P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.path),
	PositionID: getFieldNamefromDataPath(P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.schema.attributes.Position_ID.path),
	Unternehmen: getFieldNamefromDataPath(P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.schema.attributes.Unternehmen.path),
};

export const EMOB_LIS_STANDORTE_PATHS = {
	StasseUndHausnummer: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes.Strasse_Und_Hausnummer
			.path,
	),
	Plz: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes.PLZ.path,
	),
	Ort: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes.Ort.path,
	),
	GroupId: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes.Group_45_ID.path,
	),
	DarlegungBlock: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes.Darlegung_Block.path,
	),
	DarstellungDerAufstellorte: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
			.Darstellung_Der_Aufstellorte.path,
	),

	// Prüfung Assistenz
	Prufueng_Prufstatus: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
			.Projektbeschreibung_Elek_0211814995_truktur_Pruefung_Pruefstatus.path,
	),
	Prufueng_Freigegeben: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
			.Projektbeschreibung_Elek_0220823261_ktur_Pruefung_freigegeben_Am.path,
	),
	Prufueng_UeberarbeitetAm: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
			.Projektbeschreibung_Elek_0182666845_ur_Pruefung_Ueberarbeitet_Am.path,
	),
	Prufueng_Erledigt: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
			.Projektbeschreibung_Elek_0176797940_rastruktur_Pruefung_Erledigt.path,
	),
	Prufueng_HinweisAntragsteller: getFieldNamefromDataPath(
		P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.schema.attributes
			.Projektbeschreibung_Elek_0248403234_nweis_Fuer_Den_Antragsteller.path,
	),
};

/**
 * *************************************************************************************************************************************************************
 * *************************************************** Allgemein Hinweise Felde Name ***************************************************************************
 * *************************************************************************************************************************************************************
 */
export const ALLGEMEINE_HINWEISE_FELDERNAME = {
	Titel: 'Titel',
	Untertitel: 'Untertitel',
	Inhalt: 'Inhalt',
};
